export function getIndefiniteArticle(value) {
  const firstLetter = String(value || "").trim().match(/[a-z]/i)?.[0]?.toLowerCase();
  return firstLetter && "aeiou".includes(firstLetter) ? "an" : "a";
}
